import { Receipt, IndianRupee, Percent, RotateCcw, TrendingUp, Tag } from 'lucide-react';
import { money, num } from './_shared';

const STATUS_STYLE = {
  completed: 'bg-emerald-50 text-emerald-700 border-emerald-200',
  partially_returned: 'bg-amber-50 text-amber-700 border-amber-200',
  returned: 'bg-red-50 text-red-700 border-red-200',
};

export const StatusPill = ({ status }) => {
  const s = status || 'completed';
  return (
    <span className={`inline-block px-2 py-0.5 rounded-full border text-[11px] font-medium capitalize ${STATUS_STYLE[s] || 'bg-gray-50 text-gray-600 border-gray-200'}`}>
      {s.replace('_', ' ')}
    </span>
  );
};

const Stat = ({ icon: Icon, label, value, sub, tone = 'text-gray-900', testId }) => (
  <div className="rounded-lg border border-gray-200 bg-white p-4" data-testid={testId}>
    <div className="flex items-center justify-between">
      <p className="text-xs uppercase tracking-wide text-gray-500">{label}</p>
      <Icon className="w-4 h-4 text-gray-400" />
    </div>
    <p className={`mt-1 text-xl font-bold tabular-nums ${tone}`}>{value}</p>
    {sub && <p className="text-[11px] text-gray-500 mt-0.5">{sub}</p>}
  </div>
);

export const SalesSummaryCards = ({ summary }) => {
  if (!summary) return null;
  const s = summary;
  const pay = Object.entries(s.by_payment || {}).map(([k, v]) => `${k.toUpperCase()} ${money(v.amount)}`).join(' · ');
  return (
    <div className="mb-4 space-y-2" data-testid="sales-summary-cards">
      <div className="grid grid-cols-2 md:grid-cols-3 xl:grid-cols-6 gap-3">
        <Stat icon={Receipt} label="Bills" value={num(s.bill_count)} sub={`${num(s.items_qty)} items · avg ${money(s.avg_bill_value)}`} testId="sum-bills" />
        <Stat icon={IndianRupee} label="Bill Value (Incl. Tax)" value={money(s.gross_sales)} sub={`Round-off ${money(s.round_off)}`} tone="text-emerald-700" testId="sum-incl" />
        <Stat icon={Tag} label="Bill Value (Excl. Tax)" value={money(s.total_excl_tax)} sub={`After discount ${money(s.total_discount)}`} testId="sum-excl" />
        <Stat icon={Percent} label="Tax" value={money(s.total_tax)} sub={`CGST ${money(s.total_cgst)} · SGST ${money(s.total_sgst)}${s.total_igst ? ` · IGST ${money(s.total_igst)}` : ''}`} testId="sum-tax" />
        <Stat icon={RotateCcw} label="Returns" value={money(s.returns_total)} sub={`${num(s.returns_count)} returns`} tone="text-orange-600" testId="sum-returns" />
        <Stat icon={TrendingUp} label="Net Sales" value={money(s.net_sales)} sub="Incl. tax − returns" tone="text-blue-700" testId="sum-net" />
      </div>
      {pay && <p className="text-[11px] text-gray-500" data-testid="sum-payments">Collected by: {pay}</p>}
    </div>
  );
};
